import { OffCyclePayloadType } from "../../../types";

export const OFF_CYCLE_INITIAL_VALUES: OffCyclePayloadType = {
  paymentSettings: {
    payPeriodId: "",
    disbursementDate: "",
    notes: "",
  },
};
